// Fabric One: fit plan unit switch (cm / in). Every element with data-cm and data-in inside a
// [data-fo-fit] panel swaps its text. The choice is kept for the visit only (sessionStorage).
(() => {
  const KEY = 'fo-fit-unit';
  const apply = (root, unit) => {
    root.querySelectorAll('[data-cm][data-in]').forEach((el) => {
      el.textContent = unit === 'in' ? el.dataset.in : el.dataset.cm;
    });
    root.querySelectorAll('[data-unit]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.unit === unit)));
  };
  const init = () => {
    let saved = 'cm';
    try {
      saved = sessionStorage.getItem(KEY) || 'cm';
    } catch (e) {}
    document.querySelectorAll('[data-fo-fit]').forEach((root) => {
      if (root.dataset.foReady) return;
      root.dataset.foReady = '1';
      apply(root, saved);
      root.addEventListener('click', (ev) => {
        const b = ev.target.closest('[data-unit]');
        if (!b) return;
        try {
          sessionStorage.setItem(KEY, b.dataset.unit);
        } catch (e) {}
        document.querySelectorAll('[data-fo-fit]').forEach((r) => apply(r, b.dataset.unit));
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
